/**
 * src/pages/Contact.jsx
 */
import { Helmet } from "react-helmet-async";

const CONTACT_ITEMS = [
  { icon: "📞", title: "Call us", body: "+91 98735 64717", href: "tel:+919873564717" },
  { icon: "💬", title: "WhatsApp", body: "Chat with our team", href: "https://wa.me/919873804717" },
  {
    icon: "📍",
    title: "Visit the store",
    body: "157/13, Sadar Bazar Rd, near Subzi Mandi Road, Holi Ground, Roshan Pura, Gurugram, Haryana 122007",
    href: "https://www.google.com/maps/search/?api=1&query=157%2F13%20Sadar%20Bazar%20Rd%20Roshan%20Pura%20Gurugram%20Haryana%20122007",
  },
  { icon: "🕐", title: "Store timings", body: "Mon – Sun: 10:00 AM – 9:00 PM" },
  { icon: "📷", title: "Instagram", body: "@ritufashionstore", href: "https://www.instagram.com/ritufashionstore.in" },
];

export default function Contact() {

  return (
    <div className="container section">
      <Helmet>
        <title>Contact | Ritu Fashion Store, Gurgaon</title>
        <meta
          name="description"
          content="Call, WhatsApp or visit Ritu Fashion Store in Sadar Bazaar, Gurgaon for kidswear orders and sizing help."
        />
      </Helmet>

      <h1 style={{ fontSize: "2rem", fontWeight: 800 }}>Get in touch</h1>
      <p className="muted mt-2">Sizing questions, bulk orders or a custom festive set — we're happy to help.</p>

      <div style={{ marginTop: "2.5rem" }} className="contact-page-grid">
        <div>
          {CONTACT_ITEMS.map((item) => (
            <div key={item.title} className="card" style={{ background: "var(--secondary)", padding: 20, marginBottom: 16, display: "flex", gap: 12 }}>
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <div style={{ minWidth: 0 }}>
                <p style={{ fontWeight: 600, margin: 0 }}>{item.title}</p>
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noopener noreferrer" className="muted" style={{ fontSize: 14 }}>
                    {item.body}
                  </a>
                ) : (
                  <p className="muted" style={{ fontSize: 14, margin: "2px 0 0" }}>{item.body}</p>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}